module.exports = __webpack_public_path__ + "fonts/Inter-300-greek-ext38.af80f40.woff2";